import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=126061d4&"
import script from "./Loginpage.vue?vue&type=script&lang=js&"
export * from "./Loginpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports